"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.filterProps = exports.getDisplayName = exports.addClass = void 0;
var utils_1 = require("@lglp/utils");
var ramda_1 = require("ramda");
var addClass = function (classToAdd, _a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    var newClass;
    if (classToAdd) {
        if (classToAdd instanceof Array) {
            newClass = classToAdd;
        }
        else {
            newClass = [classToAdd];
        }
    }
    else {
        newClass = [];
    }
    return newClass
        .concat(className ? [processClassName(className)] : [])
        .join(' ');
};
exports.addClass = addClass;
var getDisplayName = function (Component) {
    if (ramda_1.is(String, Component)) {
        return Component;
    }
    if (!Component) {
        return undefined;
    }
    return Component.displayName || Component.name || 'Component';
};
exports.getDisplayName = getDisplayName;
var filterProps = function (Component, props) {
    var omitted = __spreadArray([
        'children',
        'className',
        'as',
        'type',
        't',
        'i18n',
        'shadowKey',
        'language',
        'dispatch'
    ], (Component.handledProps || []));
    var ret = ramda_1.omit(omitted, props);
    var className = getClassName(Component, props);
    className && (ret.className = className);
    return ret;
};
exports.filterProps = filterProps;
var whenNoCSSClass = function (Component) {
    if (Component.noCSSClass) {
        return undefined;
    }
    return exports.getDisplayName(Component);
};
var normalize = function (str) {
    return (ramda_1.is(String, str) ? str : '').replace('Component', '');
};
var createCssClassName = ramda_1.compose(function (str) { return str || ''; }, utils_1.kebabize, normalize, whenNoCSSClass);
var processClassName = ramda_1.when(ramda_1.is(Array), function (array) {
    return ramda_1.flatten(array).filter(Boolean).join(' ');
});
var getClassName = function (Component, props) {
    var defaultClassName = createCssClassName(Component);
    return processClassName([props.className, defaultClassName]);
};
//# sourceMappingURL=element.js.map